// extracted by mini-css-extract-plugin
export var content = "_qj-1";
export var fullScreen = "_qj-0";